module.exports = "/static/assets/d3cdd105293785bafc302d53039d5001.gif";